module.exports = __webpack_public_path__ + "static/media/janice.5602a179.jpg";